import * as React from "react";
import styled, { css } from "styled-components";
import {BUTTON_SIZE, WHITE} from "./constants";
import {cons} from "../../assets/react-css/const";

const buttonHover = css`
  &:hover {
    transform: scale(1.03);
  }
`;

const ButtonBase = styled.button`
  width: ${BUTTON_SIZE}px;
  height: ${BUTTON_SIZE}px;
  color: white;
  border: none;
  background-color: ${WHITE};
  border-radius: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: 0;
  cursor: pointer;
  transition: 0.2s ease-in-out;
  transform: scale(${p => (p.isOpen ? 1.03 : 1)});

  ${p => !p.isOpen && buttonHover}

  & svg {
    transition: 0.25s ease-in-out;
    transform: rotate(${p => (p.isOpen ? 45 : 0)}deg);
  }
  
  box-shadow: 0px 6px 6px rgba(71, 60, 60, 0.1);
  border-radius: 13.1866px;
`;

const Button = React.forwardRef(function Button(
    { icon, name, style, className, isOpen, onClick },
    ref
) {
    return (
        <div>
            <ButtonBase
                ref={ref}
                style={style}
                className={className}
                isOpen={isOpen}
                onClick={onClick}
            >
                {<img style={cons.iconStyle} src={require('../../assets/images/icon/modules/' + icon)} alt={""}/>}
            </ButtonBase>
            <br/>
            <div className={"module-name"}>{name !=='' ? name : ''}</div>
        </div>
    );
});

export default Button;
